import { Swiper, SwiperSlide } from "swiper/react";
import { usePubContext } from "../../hooks/pub-context";
import { PremiumPubEventImage, PremiumPubEventWrapper } from "./style";
import EnhancedImageViewer from "../../../../../components/EnhancedImageView";
import { useState } from "react";

const PremiumPubEvent = () => {
  const { data } = usePubContext();
  const [selectedImageIndex, setSelectedImageIndex] = useState(-1);

  return (
    <PremiumPubEventWrapper>
      <div className="title">매장 이벤트</div>
      <Swiper
        slidesPerView={1.1}
        centeredSlides={true}
        spaceBetween={12}
        className="swiper"
      >
        {data?.events.map((item, index) => (
          <SwiperSlide key={index}>
            <PremiumPubEventImage onClick={() => setSelectedImageIndex(index)}>
              <img src={item.imageUrl} alt="pub_image" />
            </PremiumPubEventImage>
          </SwiperSlide>
        ))}
      </Swiper>
      {selectedImageIndex !== -1 && (
        <EnhancedImageViewer
          images={data?.events.map((image) => image.imageUrl) || []}
          defaultIndex={selectedImageIndex}
          onClose={() => setSelectedImageIndex(-1)}
        />
      )}
    </PremiumPubEventWrapper>
  );
};

export default PremiumPubEvent;
